// Limpar estado anterior ao carregar o módulo
console.log('[Router] Módulo carregado, limpando estado...')

import { createRouter, createWebHistory } from 'vue-router'

// Verificar se há loop de redirecionamento
const REDIRECT_COUNT_KEY = 'kardapio-redirect-count'
const REDIRECT_TIMESTAMP_KEY = 'kardapio-redirect-timestamp'
const MAX_REDIRECTS = 3
const REDIRECT_WINDOW = 5000 // 5 segundos

// Resetar contador se passou tempo suficiente
const lastTimestamp = parseInt(localStorage.getItem(REDIRECT_TIMESTAMP_KEY) || '0')
const now = Date.now()
if (now - lastTimestamp > REDIRECT_WINDOW) {
  localStorage.removeItem(REDIRECT_COUNT_KEY)
  localStorage.removeItem(REDIRECT_TIMESTAMP_KEY)
}

const redirectCount = parseInt(localStorage.getItem(REDIRECT_COUNT_KEY) || '0')
if (redirectCount > MAX_REDIRECTS) {
  console.error('[Router] Detectado loop de redirecionamento! Limpando token...')
  localStorage.removeItem('kardapio-token')
  localStorage.removeItem(REDIRECT_COUNT_KEY)
  localStorage.removeItem(REDIRECT_TIMESTAMP_KEY)
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/LoginView.vue'),
      meta: { public: true },
    },
    {
      path: '/',
      name: 'layout',
      component: () => import('@/components/layout/MainLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => {
            // Verificar se é super-admin para mostrar dashboard correto
            const isSuperAdmin = localStorage.getItem('user-is-super-admin') === 'true'
            if (isSuperAdmin) {
              return import('@/views/dashboard/SuperAdminDashboard.vue')
            }
            return import('@/views/dashboard/DashboardView.vue')
          },
        },
        {
          path: 'dashboard/restaurant',
          name: 'restaurant-dashboard',
          component: () => import('@/views/dashboard/DashboardView.vue'),
        },
        {
          path: 'dashboard/orders',
          name: 'orders',
          component: () => import('@/views/dashboard/OrdersView.vue'),
        },
        {
          path: 'dashboard/orders/production',
          name: 'orders-production',
          component: () => import('@/views/dashboard/OrdersProductionView.vue'),
        },
        {
          path: 'dashboard/orders/new',
          name: 'order-new',
          component: () => import('@/views/dashboard/OrderFormView.vue'),
        },
        {
          path: 'dashboard/orders/:id',
          name: 'order-detail',
          component: () => import('@/views/dashboard/OrderDetailView.vue'),
        },
        {
          path: 'dashboard/menu',
          name: 'menu',
          component: () => import('@/views/dashboard/MenuView.vue'),
        },
        {
          path: 'dashboard/products',
          name: 'products',
          component: () => import('@/views/dashboard/ProductsView.vue'),
        },
        {
          path: 'dashboard/products/:id/edit',
          name: 'product-edit',
          component: () => import('@/views/dashboard/ProductFormView.vue'),
        },
        {
          path: 'dashboard/products/new',
          name: 'product-new',
          component: () => import('@/views/dashboard/ProductFormView.vue'),
        },
        {
          path: 'dashboard/categories',
          name: 'categories',
          component: () => import('@/views/dashboard/CategoriesView.vue'),
        },
        {
          path: 'dashboard/complements',
          name: 'complements',
          component: () => import('@/views/dashboard/ComplementsView.vue'),
        },
        {
          path: 'dashboard/customers',
          name: 'customers',
          component: () => import('@/views/dashboard/CustomersView.vue'),
        },
        {
          path: 'dashboard/customers/:id',
          name: 'customer-detail',
          component: () => import('@/views/dashboard/CustomerDetailView.vue'),
        },
        {
          path: 'dashboard/customers/:id/edit',
          name: 'customer-edit',
          component: () => import('@/views/dashboard/CustomerFormView.vue'),
        },
        {
          path: 'dashboard/customers/new',
          name: 'customer-new',
          component: () => import('@/views/dashboard/CustomerFormView.vue'),
        },
        {
          path: 'dashboard/reports',
          name: 'reports',
          component: () => import('@/views/dashboard/ReportsView.vue'),
        },
        {
          path: 'dashboard/settings',
          name: 'settings',
          component: () => import('@/views/dashboard/SettingsView.vue'),
        },
        {
          path: 'dashboard/delivery-fees',
          name: 'delivery-fees',
          component: () => import('@/views/dashboard/DeliveryFeesView.vue'),
        },
        {
          path: 'dashboard/payment-configs',
          name: 'payment-configs',
          component: () => import('@/views/dashboard/PaymentConfigsView.vue'),
        },
        {
          path: 'dashboard/cities',
          name: 'cities',
          component: () => import('@/views/dashboard/CitiesView.vue'),
        },
        {
          path: 'dashboard/districts',
          name: 'districts',
          component: () => import('@/views/dashboard/DistrictsView.vue'),
        },
        {
          path: 'dashboard/accounts',
          name: 'accounts',
          component: () => import('@/views/dashboard/AccountsView.vue'),
        },
        {
          path: 'dashboard/accounts/:id/edit',
          name: 'account-edit',
          component: () => import('@/views/dashboard/AccountFormView.vue'),
        },
        {
          path: 'dashboard/accounts/new',
          name: 'account-new',
          component: () => import('@/views/dashboard/AccountFormView.vue'),
        },
        {
          path: 'dashboard/companies',
          name: 'companies',
          component: () => import('@/views/dashboard/CompaniesView.vue'),
        },
        {
          path: 'dashboard/companies/:id/edit',
          name: 'company-edit',
          component: () => import('@/views/dashboard/CompanyFormView.vue'),
        },
        {
          path: 'dashboard/companies/new',
          name: 'company-new',
          component: () => import('@/views/dashboard/CompanyFormView.vue'),
        },
        {
          path: 'dashboard/group-templates',
          name: 'group-templates',
          component: () => import('@/views/dashboard/GroupTemplatesView.vue'),
        },
        {
          path: 'dashboard/group-templates/:id/edit',
          name: 'group-template-edit',
          component: () => import('@/views/dashboard/GroupTemplateFormView.vue'),
        },
        {
          path: 'dashboard/group-templates/new',
          name: 'group-template-new',
          component: () => import('@/views/dashboard/GroupTemplateFormView.vue'),
        },
        {
          path: 'dashboard/complement-items',
          name: 'complement-items',
          component: () => import('@/views/dashboard/ComplementItemsView.vue'),
        },
        {
          path: 'dashboard/complement-items/:id/edit',
          name: 'complement-item-edit',
          component: () => import('@/views/dashboard/ComplementItemFormView.vue'),
        },
        {
          path: 'dashboard/complement-items/new',
          name: 'complement-item-new',
          component: () => import('@/views/dashboard/ComplementItemFormView.vue'),
        },
        {
          path: 'dashboard/account-users',
          name: 'account-users',
          component: () => import('@/views/dashboard/AccountUsersView.vue'),
        },
        {
          path: 'dashboard/coupons',
          name: 'coupons',
          component: () => import('@/views/dashboard/CouponsView.vue'),
        },
        {
          path: 'dashboard/whatsapp-connections',
          name: 'whatsapp-connections',
          component: () => import('@/views/dashboard/WhatsAppConnectionsView.vue'),
        },
        {
          path: 'dashboard/whatsapp-providers',
          name: 'whatsapp-providers',
          component: () => import('@/views/dashboard/WhatsAppProvidersView.vue'),
          meta: { superAdminOnly: true },
        },
        {
          path: 'dashboard/external-apps',
          name: 'external-apps',
          component: () => import('@/views/dashboard/ExternalAppsView.vue'),
        },
        {
          path: 'dashboard/logs',
          name: 'logs',
          component: () => import('@/views/dashboard/LogsView.vue'),
          meta: { superAdminOnly: true },
        },
        {
          path: 'dashboard/plan',
          name: 'plan',
          component: () => import('@/views/dashboard/PlanView.vue'),
        },
        {
          path: 'dashboard/tables',
          name: 'tables',
          component: () => import('@/views/dashboard/TablesView.vue'),
        },
        {
          path: 'admin/plans',
          name: 'admin-plans',
          component: () => import('@/views/admin/PlansView.vue'),
          meta: { superAdminOnly: true },
        },
      ],
    },
    // ===== PUBLIC MENU ROUTES (Cardápio do Restaurante) =====
    {
      path: '/:restaurantSlug',
      name: 'public-menu',
      component: () => import('@/views/public/MenuLayout.vue'),
      meta: { public: true, isMenu: true },
      beforeEnter: async (to, from, next) => {
        // Valida se o slug existe
        const { publicMenuService } = await import('@/services/public-menu.service')
        const isValid = await publicMenuService.validateSlug(to.params.restaurantSlug as string)
        if (isValid) {
          publicMenuService.setRestaurantSlug(to.params.restaurantSlug as string)
          next()
        } else {
          next({ name: 'not-found' })
        }
      },
      children: [
        {
          path: '',
          name: 'menu-home',
          component: () => import('@/views/public/MenuView.vue'),
        },
        {
          path: 'product/:productId',
          name: 'menu-product',
          component: () => import('@/views/public/ProductDetailView.vue'),
        },
        {
          path: 'cart',
          name: 'menu-cart',
          component: () => import('@/views/public/CartView.vue'),
        },
        {
          path: 'checkout',
          name: 'menu-checkout',
          component: () => import('@/views/public/CheckoutView.vue'),
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue'),
    },
  ],
})

// Navigation guard
router.beforeEach((to, from, next) => {
  // Verificar autenticação diretamente do localStorage (já inicializado no main.ts)
  const token = localStorage.getItem('kardapio-token')
  const isAuthenticated = !!token
  
  console.log('[Router] beforeEach:', { path: to.path, isAuthenticated, hasToken: !!token })
  
  // Rotas públicas do cardápio não precisam de autenticação
  if (to.meta.isMenu || to.meta.public) {
    console.log('[Router] Rota pública do cardápio:', to.path)
    next()
    return
  }
  
  console.log('[Router] Navegando:', { 
    para: to.path, 
    de: from?.path || 'inicial',
    autenticado: isAuthenticated,
    tokenExiste: !!token
  })

  // Proteção contra loop
  const currentCount = parseInt(localStorage.getItem(REDIRECT_COUNT_KEY) || '0')
  localStorage.setItem(REDIRECT_COUNT_KEY, (currentCount + 1).toString())
  localStorage.setItem(REDIRECT_TIMESTAMP_KEY, Date.now().toString())

  // Se está indo para login e já está autenticado
  if (to.path === '/login' && isAuthenticated) {
    console.log('[Router] Já autenticado, indo para dashboard')
    next('/')
    return
  }
  
  // Se está indo para rota protegida e não está autenticado
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('[Router] Não autenticado, indo para login')
    next('/login')
    return
  }
  
  // Caso normal
  next()
})

export default router
